export default "__VITE_ASSET__BqlVQAQx__"